import {Injectable} from "@angular/core";
import { ConnectionBackend, RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers} from "@angular/http";
import {Observable} from "rxjs/Rx";
import {environment} from "../../../environments/environment";


import { URL_API } from '../../constante';
import { URL_CAS } from '../../constante';

@Injectable()
export class InterceptedHttp extends Http {

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
        super(backend, defaultOptions);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, options).catch((error: Response) => this.handlerError(error));
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        url = this.updateUrl(url);
        return super.get(url, this.getRequestOptionArgs(options));
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        url = this.updateUrl(url);
        return super.post(url, body, this.getRequestOptionArgs(options, body.constructor.name));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        url = this.updateUrl(url);
        return super.put(url, body, this.getRequestOptionArgs(options, body.constructor.name));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        url = this.updateUrl(url);
        return super.delete(url, this.getRequestOptionArgs(options));
    }

    private handlerError(error: any):Observable<any>{
      if (error.status === 401 )  {
          //TODO colocar o login no lugar correto
          let href = window.location.href;
          let origin = window.location.origin;

          let service = encodeURIComponent( URL_API + '/login?path=' + href);

        //  window.location.href = URL_CAS + '/login?service='+service;
      }

      return Observable.throw(error);
    }

    private updateUrl(req: string) {
        return  environment.url_api + req;
    }

    private getRequestOptionArgs(options?: RequestOptionsArgs, bodyType?: string) : RequestOptionsArgs {

        let token:string = localStorage.getItem('token');

        if (options == null) {
            options = new RequestOptions();
        }

        if (options.headers == null) {
            options.headers = new Headers();
        }

        if(bodyType !== null && bodyType !== 'FormData'){
            options.headers.append('Accept', 'application/json; text/plain, */*');
            options.headers.append('Content-Type', 'text/plain; application/json');
        }

        options.headers.append('Authorization', 'Bearer ' + token);

        return options;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/http_intercept/http.interceptor.ts